import { Typography, ListItemText, Link } from '@mui/material';
import List from '../styled/List';
import ListItemIcon from '../styled/ListItemIcon';
import ListItem from '../styled/ListItem';
import { mainPageLink } from '../utils/urls';

const PrivacyAndCookiesPolicy = () => (
  <>
    <Typography variant="h5" fontWeight="700" textTransform="none">
      7. Polityka Prywatności i Cookies.
    </Typography>
    <List>
      <ListItem>
        <ListItemIcon>7.1.</ListItemIcon>
        <ListItemText>
          Zasady przetwarzania danych osobowych w związku z korzystaniem przez
          Użytkownika z Serwisu i z Usług oraz działanie plików Cookies
          wykorzystywanych w ramach Serwisu opisane są w dokumencie „Polityka
          Prywatności i Cookies”, który jest dostępny w Serwisie. Każdy
          Użytkownik powinien zapoznać się z Polityką Prywatności i Cookies
          przed rozpoczęciem korzystania z Usług.
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemIcon>7.2.</ListItemIcon>
        <ListItemText>
          Aktualne informacje dotyczące zasad przetwarzania danych osobowych
          klientów Administratora są szczegółowo określone w klauzuli
          informacyjnej dostępnej na stronie
          <Link
            href={mainPageLink}
            color="primary.light"
            target="_blank"
            rel="nofollow"
            data-link-no-alert
          >
            {' '}
            {mainPageLink}
          </Link>{' '}
          w Zakładce „Ochrona danych osobowych”.
        </ListItemText>
      </ListItem>
    </List>
  </>
);

export default PrivacyAndCookiesPolicy;
